import React, { FC, PropsWithChildren } from "react";
import { AuthProvider } from "react-oidc-context";
import oidc from "config/oidc";

const OIDCProvider: FC<PropsWithChildren> = ({ children }) => {
  return <AuthProvider {...oidc}>{children}</AuthProvider>;
};

export default OIDCProvider;
